/**
 * EGA Recently Viewed — the single sitewide strip (M3, Phase 5; unified
 * 2026-07-18, Dan: the PDP's older bespoke version is retired).
 *
 * Reads localStorage 'ega_recently_viewed' ([{id,title,url,image,price(cents)}],
 * most-recent first — written by the PDP on every product view). Renders into
 * .ega-grv instances; when an editor-placed instance exists on the page (e.g.
 * the homepage high-placement section), the global above-footer instance stays
 * hidden so the strip never appears twice. Excludes the current product (PDR
 * M3: never show the piece you're looking at) and stays hidden until >=2
 * items remain. No network — cards render from the stored payload.
 */
(function () {
  'use strict';
  if (window.__egaGrvInit) return; /* idempotent under duplicate script tags */
  window.__egaGrvInit = true;

  var KEY = 'ega_recently_viewed';

  function money(cents) {
    if (!cents || cents <= 0) return 'Contact for Pricing';
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function pathOf(url) {
    try { return new URL(url, window.location.origin).pathname; } catch (e) { return url; }
  }

  function init() {
    var instances = Array.prototype.slice.call(document.querySelectorAll('.ega-grv'));
    if (!instances.length) return;

    /* Prefer an editor-placed instance; the global footer one only renders
       when it is the only instance on the page. */
    var placed = instances.filter(function (el) { return !el.hasAttribute('data-grv-global'); });
    var target = placed.length ? placed[0] : instances[0];

    var items = [];
    try { items = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { items = []; }
    if (!Array.isArray(items)) items = [];

    var here = window.location.pathname;
    var valid = items.filter(function (p) {
      return p && p.url && pathOf(p.url) !== here; /* never the current product */
    }).slice(0, 10);
    if (valid.length < 2) return; /* all instances stay hidden */

    var row = target.querySelector('.ega-grv-row');
    if (!row) return;
    valid.forEach(function (p) {
      var a = document.createElement('a');
      a.href = p.url;
      a.className = 'ega-grv-card';
      a.innerHTML =
        '<span class="ega-grv-card-image">' +
          (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
        '</span>' +
        '<span class="ega-grv-card-title">' + esc(p.title) + '</span>' +
        '<span class="ega-grv-card-price">' + esc(money(p.price)) + '</span>';
      row.appendChild(a);
    });

    target.hidden = false;

    /* Fade + prev/next arrows appear only when there is genuinely more to
       scroll (Dan, 2026-07-18: a fade with no way to move the items is a lie).
       Arrows step ~2 cards; native touch swipe still works on mobile. */
    var scroll = target.querySelector('.ega-grv-scroll');
    var prev = target.querySelector('.ega-grv-arrow--prev');
    var next = target.querySelector('.ega-grv-arrow--next');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function step(dir) {
      var card = row.querySelector('.ega-grv-card');
      var w = card ? (card.getBoundingClientRect().width + 16) * 2 : 280;
      row.scrollBy({ left: dir * w, behavior: reduce ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    function sync() {
      var overflow = row.scrollWidth - row.clientWidth;
      var canPrev = row.scrollLeft > 4;
      var canNext = overflow > 4 && row.scrollLeft < overflow - 4;
      if (scroll) scroll.classList.toggle('has-overflow', canNext);
      if (prev) prev.hidden = !canPrev;
      if (next) next.hidden = !canNext;
    }
    sync();
    row.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
